// extracted by mini-css-extract-plugin
export default {"form":"aYBol60pWgI0JQDl1RhV","group-mapping-form":"ZXUW09_vet8LcNuqoR8n","info-flex":"eCr9glIlsyXGt0psRFmW"};